import React from 'react';
import { PieChart, Pie, Tooltip, Cell } from 'recharts';

class GraphDistribution extends React.Component {

  customLabel = ({ cx, cy, midAngle, innerRadius, outerRadius, percent, index }) => {
   	const radius = innerRadius + (outerRadius - innerRadius) * 0.32;
    const RADIAN = Math.PI / 180;
    const x  = cx + radius * Math.cos(-midAngle * RADIAN);
    const y = cy  + radius * Math.sin(-midAngle * RADIAN);

    return (
      <text x={x} y={y} fill="white" textAnchor={x > cx ? 'start' : 'end'} 	style={{fontSize: 20, fill: 'white'}} dominantBaseline="central">
      	{`${(percent * 100).toFixed(0)}%`}
      </text>
    );
}

  render() {
    const {data, t} = this.props
    const translatedData = data && data.map( item => {
      return {name: t(item.name), value: item.value}
    })
    return (
      <PieChart width={340} height={340} id="chart-distribution">
        <Pie
          isAnimationActive={false}
          data={translatedData}
          innerRadius={90}
          outerRadius={160}
          fill="#8884d8"
          labelLine={false}
          label={this.customLabel}
          >
          {this.props.data.map((entry, index) => <Cell fill={this.props.colors.shades[index % this.props.colors.shades.length]}/>)}
        </Pie>
        <Tooltip
          cursor={false}
          wrapperStyle={styles.wrapper}
          labelStyle={styles.label}
          itemStyle={styles.label}
          />
      </PieChart>
    )
  }
}

export default GraphDistribution;

const COLORS = ['#3D7A41', '#0BED1E', '#1DD62D', '#2DBF3A', '#3D9E45'];

const styles = {

  wrapper: {
    backgroundColor: '#485465',
    border: 'none'
  },

  label: {
    fontSize: '11px'
  },

  title: {
    fontSize: '16px',
    color: '#485465'
  }

}



// WEBPACK FOOTER //
// ./src/components/GraphDistributionCluster/index.jsx